import { toObjectMap } from "@@/utilities/dictionary";
import { z } from "zod";

const feeTargets = ["provider", "customer", "alfred"] as const;
type FeeTarget = (typeof feeTargets)[number];
const feeTargetZodSchema: z.ZodSchema<FeeTarget> = z.enum(feeTargets);
const feeTarget = toObjectMap<FeeTarget>([...feeTargets]);

export { feeTargetZodSchema, feeTarget, feeTargets };
export type { FeeTarget };
